import React, {Component} from 'react'
import PropTypes from "prop-types"
import NextPagination from "../../../components/Pagination/NextPagination"


class ListItemsPagination extends Component {
    render() {
        const {page, limit, loading, total, onChange} = this.props

        return (
            <div className="ListItemsPagination">
                <NextPagination onChange={onChange} limit={limit} total={total} page={page} loading={loading}/>
            </div>
        )
    }
}

ListItemsPagination.defaultProps = {
    loading: false,
}


ListItemsPagination.propTypes = {
    page: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
}

export default ListItemsPagination
